package fr.manyverse.app.domain.usecase

/**
 * Use case for closing a digicode challenge overlay (player action).
 * This is a local operation — no database interaction required.
 * The ViewModel clears local state after calling this.
 */
class CloseDigicodeUseCase {
    operator fun invoke(): Result<Unit> = Result.success(Unit)
}
